export default __webpack_public_path__ + "static/media/squats.722b8e93.png";